import { Squares2X2Icon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const ClassesFeature: FeatureMetadata = {
  id: "classes",
  moduleName: "academics",

  navigation: {
    label: "Classes",
    path: "/classes",
    icon: Squares2X2Icon,
    order: 2,
  },

  route: {
    path: "/classes",
    element: lazy(() => import("./pages/Classes")),
  },

  permissions: {
    view: "Academics.ClassesSections.view",
    create: "Academics.ClassesSections.create",
    edit: "Academics.ClassesSections.edit",
    delete: "Academics.ClassesSections.delete",
  },

  readiness: "live",
};
